export const truncateStringByLine = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str
  }

  const words = str.split(" ")
  let result = ""
  let lineLength = 0

  for (let i = 0; i < words.length; i++) {
    const word = words[i]
    const wordLength = word.length

    if (lineLength + wordLength > maxLength) {
      result += "\n"
      lineLength = 0
    }

    result += word
    result += " "
    lineLength += wordLength + 1
  }

  return result
}

export const orderObjectArray = (arr, prop = "displayOrder") => {
  try {
    let newArr = arr.sort((a, b) => (a[prop] > b[prop] ? 1 : -1))
    return newArr
  } catch (e) {
    console.log(`can't sort array: ${e}`)
    return arr
  }
}
export const taxonomyClassNames = (currentPage = 0, taxonomy = "default") => {
  return `page-number-${currentPage} taxonomy-type-${taxonomy} index`
}
export const darkenHexColor = (hex, percent) => {
  const num = parseInt(hex.replace("#", ""), 16)
  const amt = Math.round(2.55 * percent)
  const R = (num >> 16) - amt
  const G = ((num >> 8) & 0x00ff) - amt
  const B = (num & 0x0000ff) - amt
  return `#${(0x1000000 + R + (G << 8) + (B << 16)).toString(16).slice(1)}`
}
export const stepStyle = step => {
  let style = {}
  if (step && step.backgroundImage) {
    let bgImg = step.backgroundImage.id || step.backgroundImageId
    style.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${bgImg})`
  }

  if (step && step.backgroundColor) {
    style.backgroundColor = step.backgroundColor
  }

  return style
}
export const sleep = time => {
  return new Promise(resolve => setTimeout(resolve, time))
}
